module.exports = __webpack_public_path__ + "img/zm_shipin@3x.4a578f0a.png";